var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c("h6", { staticClass: "font-weight-normal" }, [
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$t(
                `${_vm.pageID}.config.admin.custom_admin_email.recipients.title`
              )
            ) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              `${_vm.pageID}.config.admin.custom_admin_email.recipients.description`
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "emails",
                      expression: "'emails'",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyFormItem,
                    disabled: _vm.readonlyFormItem,
                    id: "input-custom_admin_email_recipients",
                    name: "custom_admin_email_recipients",
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "custom_admin_email_recipients"
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("custom_admin_email_recipients"),
                    helpText: `${_vm.pageID}.config.admin.custom_admin_email.recipients.help`,
                  },
                  model: {
                    value: _vm.form.custom_admin_email_recipients,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "custom_admin_email_recipients",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.custom_admin_email_recipients",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t(
                          `${_vm.pageID}.config.admin.custom_admin_email.recipients.label`
                        )
                      ) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("h6", { staticClass: "font-weight-normal" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(
                    _vm.$t(
                      `${_vm.pageID}.config.admin.custom_admin_email.send_options.title`
                    )
                  ) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap",
              },
              _vm._l(_vm.lists.sendOptionsEmail, function (option) {
                return _c(
                  "div",
                  {
                    key: `email-option-${option.id}`,
                    staticClass: "form-check city-form-check",
                    class: [
                      {
                        "is-invalid": _vm.fnHasError(
                          `custom_admin_email_send_options`
                        ),
                      },
                    ],
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.custom_admin_email_send_options,
                          expression: "form.custom_admin_email_send_options",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: false },
                          expression: "{required: false}",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.readonlyFormItem || !_vm.hasRecipients,
                        id: `cb-email-option-${option.id}`,
                        name: `custom_admin_email_send_options`,
                      },
                      domProps: {
                        value: option.value,
                        checked: Array.isArray(
                          _vm.form.custom_admin_email_send_options
                        )
                          ? _vm._i(
                              _vm.form.custom_admin_email_send_options,
                              option.value
                            ) > -1
                          : _vm.form.custom_admin_email_send_options,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.custom_admin_email_send_options,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = option.value,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "custom_admin_email_send_options",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "custom_admin_email_send_options",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.form,
                              "custom_admin_email_send_options",
                              $$c
                            )
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: `cb-email-option-${option.id}` },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(option.name) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }